import series100 from './1xx.json';
import series200 from './2xx.json';
import series300 from './3xx.json';
import series400 from './4xx.json';
import series500 from './5xx.json';

export default {
	'1xx': series100,
	'2xx': series200,
	'3xx': series300,
	'4xx': series400,
	'5xx': series500
};
